var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Link as RouterLink } from "react-router-dom";
import { Box } from "../../index.js";
/**
 * @param {object} props
 * @param {string | import('history').Location} [props.to] The internal link target to go to.
 * @param {string} [props.href] An external link to go to.
 * @param {((any)=>void)} [props.onClick] A click handler. I this case the link is rendered as a <button> semantically.
 * @param {string} [props.variant] The link's variant, defined in [linkVariants](./linkVariants.js).
 * @param {string} [props.className] The link styles.
 * @param {boolean} [props.replace] If set, the link replaces the current history entry.
 * @param {React.ReactNode} [props.children]
 * @param {React.ElementType} [props.as] An alternative tag to render the link as.
 * @param {string} [props.target] The link target.
 * @param {boolean} [props.noopener] Doesn't transfer the opener to the target.
 * @param {boolean} [props.noreferrer] Doesn't transfer the referrer to the target.
 * @param {React.ElementType} [props.fallback] An optional fallback if no link was provided.
 * @returns {React.ReactElement}
 */
export default function Link(_a) {
    var { to, href, onClick, variant = "default", fallback = "span", replace } = _a, rest = __rest(_a, ["to", "href", "onClick", "variant", "fallback", "replace"]);
    if (to) {
        return (
        // @ts-ignore
        _jsx(RouterLink
        // @ts-ignore
        , Object.assign({ 
            // @ts-ignore
            to: to, replace: replace, onClick: onClick, sx: {
                ":focus": { textDecoration: "none" }, // FIXME Bootstrap style spill.
                variant: `link.${variant}`,
                cursor: "pointer",
            } }, rest)));
    }
    if (href) {
        return (_jsx(Box, Object.assign({ as: "a", 
            // @ts-ignore
            href: href, onClick: onClick, sx: {
                ":focus": { textDecoration: "none" }, // FIXME Bootstrap style spill.
                variant: `link.${variant}`,
                cursor: "pointer",
            } }, rest)));
    }
    if (onClick) {
        return (_jsx(Box, Object.assign({ as: "button", onClick: onClick, sx: { variant: `link.${variant}`, cursor: "pointer" } }, rest)));
    }
    return (_jsx(Box, Object.assign({ as: fallback, sx: { variant: `link.${variant}`, cursor: "pointer" } }, rest)));
}
//# sourceMappingURL=Link.js.map